import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '../__root';

const magicLinkSearchSchema = z.object({
  token: z.string().optional(),
});

export const magicLinkCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth/magic-link/callback',
  validateSearch: magicLinkSearchSchema,
  component: lazyRouteComponent(
    () => import('@/features/auth/MagicLinkCallbackContent'),
    'MagicLinkCallbackContent',
  ),
});
